<div class="rivit-osio">
  <div class="rt-wrap">
    <table class="rt">
      <colgroup>
        <col class="col-kahva" />
        <col />
        @if (naytaProjektit) {
          <col class="col-projekti" />
        }
        <col class="col-maara" />
        <col class="col-ahinta" />
        <col class="col-alv" />
        @if (naytaAlennus) {
          <col class="col-ale" />
        }
        <col class="col-yhteensa" />
        <col class="col-valikko" />
      </colgroup>
      <thead>
        <tr>
          <th></th>
          <th class="th-kuvaus">{{ 'lasku.tuote-kuvaus' | translate | async }}</th>
          @if (naytaProjektit) {
            <th>{{ 'lasku.projekti' | translate | async }}</th>
          }
          <th class="th-maara">{{ 'lasku.maara' | translate | async }}</th>
          <th class="r">
            @if (naytaHinnanVerollisuusvalinta) {
              <span class="hinnan-syottotapa">
                {{ (parent.hinnatVerollisina().value() ? 'lasku.a-hinta-verollinen-valinta' : 'lasku.a-hinta-veroton-valinta') | translate | async }}
                <mat-icon>expand_more</mat-icon>
                <select (change)="valitseHinnatVerollisina($any($event.target).value === 'true')" [attr.aria-label]="'lasku.a-hinta-syottotapa' | translate | async">
                  <option value="false" [selected]="!parent.hinnatVerollisina().value()">{{ 'lasku.a-hinta-veroton-valinta' | translate | async }}</option>
                  <option value="true" [selected]="parent.hinnatVerollisina().value()">{{ 'lasku.a-hinta-verollinen-valinta' | translate | async }}</option>
                </select>
              </span>
            } @else {
              {{ 'lasku.a-hinta-veroton' | translate | async }}
            }
          </th>
          <th>{{ 'lasku.rivit.alv' | translate | async }}</th>
          @if (naytaAlennus) {
            <th class="r">{{ 'lasku.rivit.alennus' | translate | async }}</th>
          }
          <th class="r">{{ 'lasku.tuote-yhteensa-veroton' | translate | async }}</th>
          <th></th>
        </tr>
      </thead>
      @for (tuote of parent.tuotteet; track tuote; let i = $index) {
        <tbody
          app-lasku-rivi
          [parent]="tuote"
          [alvt]="alvtObservable | async"
          [alvinLukituksenSelite]="alvinLukituksenSelite"
          [rekisterivalintaKaytossa]="rekisterivalintaKaytossa"
          [laskunValuutta]="parent.valuutta().value()"
          [naytaProjektit]="naytaProjektit"
          [naytaAlennus]="naytaAlennus"
          [sarakkeita]="sarakkeita"
          [paivitaValidaatiot]="paivitaValidaatiot"
          [riviaRaahataan]="raahattavaIndeksi === i"
          [riviOnRaahauksenKohde]="raahauksenKohdeIndeksi === i && raahattavaIndeksi !== i"
          (validaatioMuuttuiTapahtuma)="validaatioMuuttuiTapahtumakuuntelija($event, i)"
          (riviPoistettuTapahtuma)="rivinPoistamisenKuuntelija($event)"
          (riviMonistettuTapahtuma)="monistaRivi($event)"
          (alennusLisattiinTapahtuma)="avaaAlennussarakeJaKohdistaRiviin(i)"
          (siirrySeuraavalleRivilleTapahtuma)="siirrySeuraavalleRiville(i)"
          (rivinRaahausAlkoiTapahtuma)="raahausAlkoi(i)"
          (rivinRaahausLoppuiTapahtuma)="raahausLoppui()"
          (raahattuRiviPudotettiinTalleTapahtuma)="pudotaRivi(i)"
          (dragenter)="raahauksenKohdeIndeksi = i"
        ></tbody>
      }
      <tbody app-uusi-laskurivi-haku [laskunValuutta]="parent.valuutta().value()" [sarakkeita]="sarakkeita" (rekisterituoteValittiinTapahtuma)="lisaaRiviRekisterituotteesta($event)" (vapaaRiviLisattiinTapahtuma)="lisaaVapaaRivi($event)"></tbody>
    </table>
  </div>

  @if (onkoVirhe(parent.tuotteet, 'min') && parent.tuotteet().touched()) {
    <div class="lemon-error" style="margin-top: 10px">
      {{ 'lasku.validation.tuotteet.min' | translate | async }}
    </div>
  }

  @if ((virheetObservable | async)?.length > 0) {
    <div class="lemon-error" style="margin-bottom: 30px">
      @for (virhe of virheetObservable | async; track virhe; let i = $index) {
        <div>
          @if (virhe?.virheet) {
            <div>
              {{ 'lasku.validation.rivin-alku' | translate: { rivi_nro: i + 1 } | async }}
              @for (err of virhe?.virheet; track err) {
                <span>
                  {{ 'lasku.validation.' + err.field + '.' + err.error | translate | async }}
                </span>
              }
            </div>
          }
        </div>
      }
    </div>
  }

  <div class="liitteet">
    <app-lemonaid-button mat-button (click)="lisaaLiite()" actionId="Valitse tiedosto: Lisää laskun liitetiedosto" additionalClass="linkkinappi" matIcon="attach_file">
      {{ 'lasku.lisaa-liite' | translate | async }}
    </app-lemonaid-button>

    @if (kuvavirheAvain()) {
      <div class="red-text" style="padding: 2vh 3vh 2em 2em">{{ kuvavirheAvain() | translate: kuvavirheParametrit() | async }}</div>
    }

    @if (parent.liitetiedostot().value().length > 0) {
      <div style="padding-top: 10px">
        <mat-chip-listbox>
          @for (liite of parent.liitetiedostot; track liite; let i = $index) {
            <mat-chip-option style="height: unset" [removable]="true" (removed)="poistaLiitetiedosto(liite().value(), i)">
              <div style="display: flex; flex-flow: wrap; width: 100%">
                <div style="display: flex; flex-flow: nowrap; width: 100%; justify-content: space-between">
                  @if (liite().value().uploadDone) {
                    <div>{{ liite().value().nimi }}</div>
                  }
                  @if (!liite().value().uploadDone) {
                    <div>{{ 'lasku.ladataan' | translate | async }} {{ liite().value().nimi }}...</div>
                  }
                  <mat-icon matChipRemove>cancel</mat-icon>
                </div>
                @if (!liite().value().uploadDone) {
                  <div style="width: 100%; padding: 10px 0">
                    <mat-progress-bar mode="determinate" [value]="liite().value().uploadDonePercentage" style="width: calc(100% - 25px)"></mat-progress-bar>
                  </div>
                }
                @if (liite().value().uploadError) {
                  <div class="error-text" style="width: calc(100% - 25px); padding: 10px 0">{{ 'lasku.tiedoston-lahettaminen-epaonnistui-alku' | translate | async }} "{{ annaVirheteksti(liite().value().uploadError) }}". {{ 'lasku.tiedoston-lahettaminen-epaonnistui-loppu' | translate | async }}</div>
                }
              </div>
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
    }
  </div>
</div>

<input style="visibility: hidden; height: 1px" (change)="fileChanged($event)" type="file" accept="image/*,application/pdf" #fileInput multiple="multiple" />
